module.exports = __webpack_public_path__ + "img/blue.5cc8ec26.webp";